export default __webpack_public_path__ + "static/media/vire7.2af905a0.jpg";